

<div class="relative " [class.circle]="circle">

  <div *ngIf="!imagePreview" class=" w-full border-3 border-white surface-ground border-circle flex align-items-center justify-content-center" style="aspect-ratio: 1/1;">
    <i class="pi pi-user" style="font-size: 4rem;"></i>
  </div>

  <img
    *ngIf="imagePreview"
    class="w-full {{ circle ? 'border-circle border-3 border-white' : '' }} "
    [src]="imagePreview"
    [alt]="'admin.image-input.image.alt' | translate"/>

    <div class="absolute" style="right: 1%; bottom: 1%;">
      <button (click)="triggerFileInput$.next()" pButton icon="pi pi-pencil" class="p-button-rounded"></button>
    </div>
</div>

<app-image-load-crop
  [triggerFileInput$]="triggerFileInput$"
  [maintainAspectRatio]="maintainAspectRatio"
  (editedImageBase64)="onImage($event)" class="hidden">
</app-image-load-crop>
